import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCompassPointer"><Path d="M21.5234 21.3867L12 17.5771L2.47656 21.3867L12 1.7041L21.5234 21.3867Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointer;
